import { useEffect, useRef, useCallback } from "react";

export const useScrollbarVisibility = () => {
  const scrollTimeoutRef = useRef(null);

  const handleScroll = useCallback((element) => {
    if (!element) return;

    element.classList.add("scrolling");

    if (scrollTimeoutRef.current) {
      clearTimeout(scrollTimeoutRef.current);
      scrollTimeoutRef.current = null;
    }

    scrollTimeoutRef.current = setTimeout(() => {
      // element may be detached/unmounted
      if (element?.classList) {
        element.classList.remove("scrolling");
      }
      scrollTimeoutRef.current = null;
    }, 1000);
  }, []);

  const setupScrollListener = useCallback(
    (element) => {
      if (!element) return () => {}; // ✅ ALWAYS return cleanup

      const scrollHandler = () => handleScroll(element);

      element.addEventListener("scroll", scrollHandler, { passive: true });

      return () => {
        element.removeEventListener("scroll", scrollHandler);

        if (scrollTimeoutRef.current) {
          clearTimeout(scrollTimeoutRef.current);
          scrollTimeoutRef.current = null;
        }
      };
    },
    [handleScroll],
  );

  useEffect(() => {
    return () => {
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
        scrollTimeoutRef.current = null;
      }
    };
  }, []);

  return { setupScrollListener };
};
